export default "__VITE_ASSET__Czs44Hhm__"